// extracted by mini-css-extract-plugin
export var logo = "_iy-2";
export var logoWrapper = "_iy-1";
export var strip = "_iy-0";